import {create} from "@targoninc/jess";

export function skeletonLine(width: string = "100%", height: string = "1em") {
    return create("div")
        .classes("skeleton-line", "skeleton-animate")
        .css({ width, height })
        .build();
}

export function skeleton() {
    return create("div")
        .classes("content-wrapper", "flex-v")
        .children(
            create("div")
                .classes("content", "skeleton-container")
                .children(
                    skeletonLine("60%", "2em"), // title
                    skeletonLine(),
                    skeletonLine(),
                    skeletonLine(),
                    skeletonLine("80%")
                ).build()
        ).build();
}

export function sidebarSkeleton() {
    return create("div")
        .classes("sidebar", "flex-v", "no-gap", "skeleton-container")
        .css({ padding: "1em" })
        .children(
            skeletonLine("70%", "1.2em"),
            skeletonLine("50%", "1.2em"),
            skeletonLine("80%", "1.2em"),
            skeletonLine("60%", "1.2em"),
            skeletonLine("40%", "1.2em"),
            skeletonLine("75%", "1.2em")
        ).build();
}
